import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from "react-intl";

import {setCabinetsApplyTo, setCabinetsApplyToBathroom} from "../../../actions/navigationFunctions";
import {getCurrentLayout} from "../../appLayout";
import UiSelect from "../../ui/select";
import {CABINET_GROUP} from "../core/constants";
import Analytics from '../../../analytics';
import {CABINET_GROUP_BATHROOM} from "../../bvSceneComponent/core/constants";
import store from "../../../store";
import {getFeatureGroupName} from "../../../misc/helpers";
import {getMissingFeaturesAndClickThem} from "../../look/lookNavigation/lookNavigationFunctions";

class CabinetSwitchers extends Component {

  static propTypes = {
    activeSubPart: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
  };

  componentDidMount() {
    const cabinetsApplyTo = this.getCabinetsApplyTo();
    const setCabinetsApplyTo = this.getSetCabinetsApplyTo();
    if (!cabinetsApplyTo.includes(this.props.activeSubPart.partId)) {
      cabinetsApplyTo.push(this.props.activeSubPart.partId);
      setCabinetsApplyTo(cabinetsApplyTo);
    }
  }

  toggleCabinetsApplyTo = (partId) => {
    Analytics.sendClickEvent('cabinets-apply-to-' + partId);
    let cabinetsApplyTo = [...this.getCabinetsApplyTo()];
    const setCabinetsApplyTo = this.getSetCabinetsApplyTo();
    const existingIndex = cabinetsApplyTo.findIndex(cabinetsApplyToPartId => cabinetsApplyToPartId === partId);
    if (existingIndex > -1) {
      cabinetsApplyTo.splice(existingIndex, 1)
    } else {
      cabinetsApplyTo.push(partId)
    }
    setCabinetsApplyTo(cabinetsApplyTo);
  };

  getButtonName = (partId, layout) => {
    const {intl, fabricatorData} = this.props;
    if (intl.locale !== "en-EN") {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup) {
        return getFeatureGroupName(featureGroup, intl, fabricatorData)
      }
    }
    switch (partId) {
      case "top_cabinet":
        return this.props.showAsDropdown ? "upper cabinet" : "upper";
      case "bottom_cabinet":
        return this.props.showAsDropdown ? "lower cabinet" : "lower";
      case "center_island_cabinet":
        return "center island";
      case "vanity_cabinet":
        return "Cabinet";
      case "vanity_mirror":
        return "Mirror";
      default:
        return ""
    }
  };

  static getFeatureDoorStyleFilter = (feature, filterName = "DoorStyle") => {
    if (!feature) {
      return null
    }
    const filterGroups = store.getState().filterState.filterGroups;
    const doorStyleFilterGroup = filterGroups.find(group => group.name === filterName);
    return doorStyleFilterGroup && (feature.dbFeature.fabFilterValueIDs[doorStyleFilterGroup.id] || feature.dbFeature.filterValueIDs[doorStyleFilterGroup.id])
  };

  static getNeededFeatureFromNavItems = (navigationItemName, featureGroup) => {
    return featureGroup.features.find((feature) => {
      const featureName = feature.getSplittedFeatureName().replace(`${feature.dbFeature.groupName} - `, "");
      return featureName && navigationItemName && (featureName === navigationItemName)
    });
  }

  static applyClickTo = async (navigationItemPart, ignoreLocked, cabinetsApplyTo, setCurrentFeature = false) => {
    const layout = getCurrentLayout();
    let missingFeatures = [];
    for (const neededPartId of cabinetsApplyTo) {
      const featureGroup = layout.getFeatureGroupByPartId(neededPartId);
      if (!featureGroup) {
        continue;
      }
      let neededFeature;
      if (document.kvConfig.visualizerType === "bvScene") {
        const doorStyles = CabinetSwitchers.getFeatureDoorStyleFilter(navigationItemPart, "DoorStyle");
        const materials = CabinetSwitchers.getFeatureDoorStyleFilter(navigationItemPart, "Material");
        neededFeature = doorStyles && featureGroup.features.find((feature) => {
          const featureDoorStyles = CabinetSwitchers.getFeatureDoorStyleFilter(feature, "DoorStyle");
          const featureMaterials = CabinetSwitchers.getFeatureDoorStyleFilter(feature, "Material");
          return doorStyles && featureDoorStyles && materials && featureMaterials
            && (featureDoorStyles.some(ds => doorStyles.includes(ds)))
            && (featureMaterials.some(mat => materials.includes(mat)))
        });
      } else {
        const navigationItemName = navigationItemPart.getSplittedFeatureName().replace(`${navigationItemPart.dbFeature.groupName} - `, "");
        neededFeature = CabinetSwitchers.getNeededFeatureFromNavItems(navigationItemName, featureGroup);
        if (!neededFeature
          && (!featureGroup.alreadyRequestedFeatureNames || !featureGroup.alreadyRequestedFeatureNames.includes(navigationItemName))
          && !(featureGroup.partId === "fridge_enclosure" && layout.type === 1)) {
          missingFeatures.push({relatedItem: featureGroup, navigationItemName, setCurrentFeature: true})
        }
      }
      if (neededFeature) {
        if (setCurrentFeature) {
          featureGroup.activeFeatureBeforeAllWalls = featureGroup.activeFeature;
        }
        neededFeature.clickFromAllWalls(ignoreLocked);
      }
    }
    if (missingFeatures.length) {
      await getMissingFeaturesAndClickThem(missingFeatures, true)
    }
    return Promise.resolve()
  }

  static applyAllCabinets = (navigationItemPart, ignoreLocked) => {
    const propsCabinetsApplyTo = store.getState().navigationState[
      document.kvConfig.visualizerType === "bvScene" ? "cabinetsApplyToBathroom" : "cabinetsApplyTo"
      ];
    const cabinetsApplyTo = [...propsCabinetsApplyTo];
    const existingIndex = cabinetsApplyTo.findIndex(cabinetsApplyToPartId => cabinetsApplyToPartId === navigationItemPart.partId);
    if (existingIndex > -1) {
      cabinetsApplyTo.splice(existingIndex, 1); // remove already clicked partId
    }
    return CabinetSwitchers.applyClickTo(navigationItemPart, ignoreLocked, cabinetsApplyTo)
  };

  getValueText = () => {
    if (this.props.windowWidth < 720) {
      return <FormattedMessage id="quotingTool.cabinetSwitchersLabelSmallScreens"/>
    } else if (this.props.windowWidth < 800) {
      return <FormattedMessage id="quotingTool.cabinetSwitchersLabelMediumScreens"/>
    } else {
      return <FormattedMessage id="quotingTool.cabinetSwitchersLabelLargeScreens"/>
    }
  };

  buttonIsDisabled = (partId) => {
    const layout = getCurrentLayout();
    return this.props.activeSubPart.partId === partId
      || (document.kvConfig.visualizerType === "Kitchen" && partId === "center_island_cabinet"
        && !layout.getCurrentLayoutAbbreviation().includes("I"));
  }

  renderDropDown = () => {
    const CABINETGROUPS = this.getCabinetGroups();
    const cabinetsApplyTo = this.getCabinetsApplyTo();
    const layout = getCurrentLayout();

    return (
      <UiSelect type={1}
                selectItems={CABINETGROUPS}
                withCheckboxes={true}
                valueText={this.getValueText()}>
        {CABINETGROUPS.map(partId => {
          const disabledButton = this.buttonIsDisabled(partId);
          return (
            <li key={"dropdownRelated"+partId}
                className={"ui-select__dropdown-list-item"}>
              <span className={"ui-checkbox ui-checkbox--small"
              + (disabledButton || cabinetsApplyTo.includes(partId) ? " ui-checkbox--checked" : "")
              + (disabledButton ? " ui-checkbox--disabled" : "")}
                    onClick={() => disabledButton ? false : this.toggleCabinetsApplyTo(partId)}/>
              <span className={"ui-checkbox__label" + (disabledButton ? " ui-checkbox__label--disabled" : "")}
                    onClick={() => disabledButton ? false : this.toggleCabinetsApplyTo(partId)}>
                {this.getButtonName(partId, layout)}
              </span>
            </li>
          )
        })}
      </UiSelect>
    )
  };

  getCabinetGroups = () => {
    if (document.kvConfig.visualizerType === "bvScene") {
      return CABINET_GROUP_BATHROOM
    }
    return [...CABINET_GROUP].filter(partId => partId !== "fridge_enclosure");
  };

  getCabinetsApplyTo = () => {
    return document.kvConfig.visualizerType === "bvScene" ? this.props.cabinetsApplyToBathroom : this.props.cabinetsApplyTo;
  };

  getSetCabinetsApplyTo = () => {
    return document.kvConfig.visualizerType === "bvScene" ? this.props.setCabinetsApplyToBathroom : this.props.setCabinetsApplyTo;
  };

  render() {
    const CABINETGROUPS = this.getCabinetGroups();
    if (this.props.showAsDropdown) {
      return this.renderDropDown()
    }
    const cabinetsApplyTo = this.getCabinetsApplyTo();
    const layout = getCurrentLayout();
    return (
      <div className={"cabinets" + (this.props.isMobile ? " cabinets--mobile" : "")}>
        <div className="cabinets-title bold">Apply to</div>
        <ul className="cabinets-buttons">
          {CABINETGROUPS.map(partId => {
            const hideButton = this.buttonIsDisabled(partId);
            return hideButton ? null : (
              <li key={partId}
                  className={"cabinets-buttons__button cabinets-buttons__button--" + partId
              + (cabinetsApplyTo.includes(partId) ? " cabinets-buttons__button--selected" : "")}
                  onClick={() => this.toggleCabinetsApplyTo(partId)}>
                <span className="cabinets-buttons__button-icon"/>
                <span className="cabinets-buttons__button-text bold">{this.getButtonName(partId, layout)}</span>
                <div className="cabinets-buttons__button-radio">
                  <button className={"ui-radio ui-radio--small"
                  + (cabinetsApplyTo.includes(partId) ? " ui-radio--checked" : "")}>
                    <span className="ui-radio-circle"/>
                    <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
                    <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
                  </button>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  cabinetsApplyTo: store.navigationState.cabinetsApplyTo,
  cabinetsApplyToBathroom: store.navigationState.cabinetsApplyToBathroom,
  windowWidth: store.serverState.windowWidth,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setCabinetsApplyTo,
  setCabinetsApplyToBathroom
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CabinetSwitchers)
);
